import { render } from "./WalletBuyStep.vue?vue&type=template&id=6bb6bba0&scoped=true"
import script from "./WalletBuyStep.vue?vue&type=script&lang=js"
export * from "./WalletBuyStep.vue?vue&type=script&lang=js"

import "./WalletBuyStep.vue?vue&type=style&index=0&id=6bb6bba0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb6bba0"]])

export default __exports__